export default __webpack_public_path__ + "static/media/active-btn.55504033.webp";